import * as types from 'src/store/mutation-types'
import { StatisticsClient } from 'src/api/Statistics'
import { date } from 'quasar'

// initial state
// shape: [{ id, quantity }]
const state = {
  statisticsLoaded: false,
  overdueInvoiceAmount: null,
  overdueInvoiceNumber: null,
  unpaidInvoiceAmount: null,
  unpaidInvoiceNumber: null,
  newCustomers: null,
  totalCustomers: null,
  revenue: null,
  expensesStatistic: null,
  notCapturedExpenses: null,
  revenueAverage: null,
  expensesAverage: null,
  revenueAverageYear: new Date().getFullYear(),
  expensesAverageYear: new Date().getFullYear()
}

// getters
const getters = {
  statisticsLoaded: state => state.statisticsLoaded,
  overdueInvoiceAmount: state => state.overdueInvoiceAmount,
  overdueInvoiceNumber: state => state.overdueInvoiceNumber,
  unpaidInvoiceAmount: state => state.unpaidInvoiceAmount,
  unpaidInvoiceNumber: state => state.unpaidInvoiceNumber,
  newCustomers: state => state.newCustomers,
  totalCustomers: state => state.totalCustomers,
  revenue: state => state.revenue,
  expensesStatistic: state => state.expensesStatistic,
  notCapturedExpenses: state => state.notCapturedExpenses,
  revenueAverage: state => state.revenueAverage,
  expensesAverage: state => state.expensesAverage
}

const actions = {
  fetchStatisticsOverview ({ commit, state }, options = {}) {
    const firstDayOfDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    const startDate = date.formatDate(date.subtractFromDate(firstDayOfDate, { month: 12 }), 'YYYY-MM-DD')

    const data = {
      'statistics': [
        { 'name': 'overdue_invoice_amount' },
        { 'name': 'overdue_invoice_number' },
        { 'name': 'unpaid_invoice_amount' },
        { 'name': 'unpaid_invoice_number' },
        { 'name': 'new_customers', 'options': { 'unit': 'month', 'start_date': startDate, 'chunk_size': 1 } },
        { 'name': 'revenue', 'options': { 'unit': 'month', 'start_date': startDate, 'chunk_size': 1 } },
        { 'name': 'expenses', 'options': { 'unit': 'month', 'start_date': startDate, 'chunk_size': 1 } },
        { 'name': 'not_captured_expenses' },
        { 'name': 'revenue_average', 'options': { 'year': state.revenueAverageYear } },
        { 'name': 'expenses_average', 'options': { 'year': state.expensesAverageYear } }
      ]
    }

    return new StatisticsClient()
      .list(data)
      .then(response => {
        const values = response.data.data

        let data = {
          overdueInvoiceAmount: values.find(statistic => statistic.name === 'overdue_invoice_amount'),
          overdueInvoiceNumber: values.find(statistic => statistic.name === 'overdue_invoice_number'),
          unpaidInvoiceAmount: values.find(statistic => statistic.name === 'unpaid_invoice_amount'),
          unpaidInvoiceNumber: values.find(statistic => statistic.name === 'unpaid_invoice_number'),
          newCustomers: values.find(statistic => statistic.name === 'new_customers'),
          revenue: values.find(statistic => statistic.name === 'revenue'),
          expensesStatistic: values.find(statistic => statistic.name === 'expenses'),
          notCapturedExpenses: values.find(statistic => statistic.name === 'not_captured_expenses'),
          revenueAverage: values.find(statistic => statistic.name === 'revenue_average'),
          expensesAverage: values.find(statistic => statistic.name === 'expenses_average')
        }

        commit(types.SET_STATISTICS, data)
        commit(types.SET_STATISTICS_LOADED, true)
      })
  },

  setRevenueAverageYear ({ commit }, value) {
    commit(types.SET_REVENUE_AVERAGE_YEAR, value)
  },

  setExpensesAverageYear ({ commit }, value) {
    commit(types.SET_EXPENSES_AVERAGE_YEAR, value)
  }
}

// mutations
const mutations = {
  [types.SET_STATISTICS] (
    state,
    {
      overdueInvoiceAmount,
      overdueInvoiceNumber,
      unpaidInvoiceAmount,
      unpaidInvoiceNumber,
      newCustomers,
      totalCustomers,
      revenue,
      expensesStatistic,
      notCapturedExpenses,
      revenueAverage,
      expensesAverage
    }
  ) {
    state.overdueInvoiceAmount = overdueInvoiceAmount
    state.overdueInvoiceNumber = overdueInvoiceNumber
    state.unpaidInvoiceAmount = unpaidInvoiceAmount
    state.unpaidInvoiceNumber = unpaidInvoiceNumber
    state.newCustomers = newCustomers
    state.totalCustomers = totalCustomers
    state.revenue = revenue
    state.expensesStatistic = expensesStatistic
    state.notCapturedExpenses = notCapturedExpenses
    state.revenueAverage = revenueAverage
    state.expensesAverage = expensesAverage
  },

  [types.SET_STATISTICS_LOADED] (state, value) {
    state.statisticsLoaded = value
  },

  [types.SET_REVENUE_AVERAGE_YEAR] (state, value) {
    state.revenueAverageYear = value
  },

  [types.SET_EXPENSES_AVERAGE_YEAR] (state, value) {
    state.expensesAverageYear = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
